import { render, staticRenderFns } from "./doc-card.vue?vue&type=template&id=3f9dfc89&scoped=true&"
import script from "./doc-card.vue?vue&type=script&lang=js&"
export * from "./doc-card.vue?vue&type=script&lang=js&"
import style0 from "./doc-card.vue?vue&type=style&index=0&id=3f9dfc89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9dfc89",
  null
  
)

export default component.exports